import { skipToken } from "@reduxjs/toolkit/query";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useGetDaysSupplyForPriceQuery } from "src/api/services/daysSupplyApi";
import { useGetTitrationsQuery } from "src/api/services/titrationApi";
import { ProductPrice } from "src/api/types";
import StatusBadge from "src/shared/StatusBadge";

interface Props {
  price: ProductPrice;
}

const PriceStatusBadge = ({ price }: Props) => {
  const { data: titrations = [] } = useGetTitrationsQuery(
    price.has_titration
      ? {
          price_id: price.id,
        }
      : skipToken,
  );
  const { data: daysSupply = [] } = useGetDaysSupplyForPriceQuery({
    price_id: price.id,
    product_id: price.product_id,
  });
  const navigate = useNavigate();

  const handleNavigate = useCallback(
    (key: string) => {
      localStorage.setItem(key, "true");
      navigate(`${price.id}`);
    },
    [navigate, price.id],
  );

  if (daysSupply.length === 0) {
    return (
      <StatusBadge
        status="warning"
        title="Days Supply required. Click to update this price"
        onNavigate={() => handleNavigate("open-days-supply")}
      />
    );
  }

  if (price.has_titration && titrations.length === 0) {
    return (
      <StatusBadge
        status="warning"
        title="Titration required. Click to update this price"
        onNavigate={() => handleNavigate("open-titration")}
      />
    );
  }

  return <StatusBadge status="success" />;
};

export default PriceStatusBadge;
